import Http from '../../http';
class BidServices {
  static async filterWithCabRequest(data) {
    return Http.post('/bid/filter', data);
  }
}
export default BidServices;
